import { TestUtil } from './TestUtil';
import { UIUtil } from './UIUtil';

export function LoadUtil() {}

LoadUtil.TEXT = 'text';
LoadUtil.XML = 'xml';
LoadUtil.JSON = 'json';
LoadUtil.URL_VARS = 'urlVars';
//LoadUtil.SECRET = "HN7CL9dgVQ8YJjqw";
//Private static properties
LoadUtil._sounds = {};
LoadUtil._muted = false;
LoadUtil._loopSound = null as string | null;
LoadUtil._loopChannel = null;
LoadUtil._loopStopped = false;
LoadUtil._SoundLevel = 'Full';
let soundLoopInstance = null as createjs.AbstractSoundInstance | null;

//Public static methods

createjs.Sound.alternateExtensions = ['ogg', 'mp3'];

LoadUtil.load = function (url, callback, dataType?, thisArg?) {
  LoadUtil.post(url, null, callback, dataType, thisArg);
};

LoadUtil.preview = function (callback, thisArg?, response?) {
  if (callback) setTimeout(() => callback.call(thisArg, response || {}), 10);
};

// Does not support URL vars
LoadUtil.get = function (url: string, callback, dataType?, thisArg?) {
  if (dataType == null) dataType = LoadUtil.JSON;

  $.ajax({
    type: 'GET',
    url: url,
    cache: false,
    dataType: dataType,
  })
    .done(function (response) {
      if (callback) callback.call(thisArg, response);
    })
    .fail(function (e) {
      TestUtil.warn('Error getting ' + url + '\n' + e);
      if (callback) callback.call(thisArg, null);
    });
};

LoadUtil.post = function (url: string, data, callback?, dataType?, thisArg?) {
  let toVars = false;
  if (dataType == null) dataType = 'text';

  if (dataType == 'urlVars') {
    dataType = 'text';
    toVars = true;
  }

  $.ajax({
    type: 'POST',
    url: url,
    cache: false,
    data: data,
    dataType: dataType,
  })
    .done(function (response) {
      if (toVars) response = LoadUtil._toVarsObj(response);
      if (callback) callback.call(thisArg, response);
    })
    .fail(function (e) {
      try {
        const responseJson = JSON.parse(e.responseText);
        if (callback) callback.call(thisArg, responseJson);
      } catch (e) {
        if (callback) callback.call(thisArg, null);
      }
    });
};

//LoadUtil.createVarsObject = function () {
//	return {};
//}

//LoadUtil.callScript = function(url, data){
//	$.ajax({
//		type: 'POST',
//		url: url,
//		data: data,
//		cache: false
//	}).error(function() { TestUtil.warn("Error: Failed to call script '"+url+"'"); });
//}

/* Images */

LoadUtil.loadImage = function (src) {
  return new createjs.Bitmap(src);
};

/* Sounds */
LoadUtil.mute = function () {
  //TestUtil.log("mute");
  LoadUtil._muted = true;
  if (LoadUtil._loopSound) {
    //TestUtil.log("stopLoopSound()");
    createjs.Sound.stop();
  }
};

LoadUtil.unmute = function () {
  //TestUtil.log("unmute");
  LoadUtil._muted = false;
  if (!LoadUtil._loopStopped) {
    TestUtil.log('startLoop');
    LoadUtil.playLoopSound();
  }
};

LoadUtil.toggleMute = function () {
  //TestUtil.log("toggleMute");
  if (LoadUtil._muted) LoadUtil.unmute();
  else LoadUtil.mute();
};
LoadUtil.loadSound = function (src, id) {
  //TestUtil.log("loadSound("+src+")");
  try {
    src = src.replace(/ /g, '%20');
    createjs.Sound.registerSound(src, id);
  } catch (e) {
    TestUtil.warn(e);
  }
};
LoadUtil.playSound = function (id) {
  //TestUtil.log("playSound");
  if (!LoadUtil._muted) var instance = createjs.Sound.play(id);
};

LoadUtil.playSoundOverrideMute = function (id) {
  //TestUtil.log("playSoundOverridMute");
  const instance = createjs.Sound.play(id);
};
LoadUtil.playSoundAtVolume = function (id, volume) {
  //TestUtil.log("playSoundAtVolume");
  if (!LoadUtil._muted) {
    const instance = createjs.Sound.play(id);
    instance.volume = volume;
  }
};
LoadUtil.stopAllSounds = function () {
  //TestUtil.log("stopAllSounds");
  LoadUtil._loopStopped = true;
  createjs.Sound.stop();
};
LoadUtil.startLoop = function (src) {
  //TestUtil.log("startLoop");
  LoadUtil.loadLoopSound(src);
  LoadUtil._loopStopped = false;
};

LoadUtil.stopLoop = function () {
  //TestUtil.log("stopLoop");
  LoadUtil._loopStopped = true;
  createjs.Sound.stop();
};

LoadUtil.restartLoop = function () {
  //TestUtil.log("restartLoop");
  createjs.Sound.stop();
  LoadUtil._loopStopped = false;
  LoadUtil.playLoopSound();
};
LoadUtil.loadLoopSound = function (src) {
  //TestUtil.log("loadLoopSound("+src+")");
  LoadUtil._loopSound = 'loop'; //This should really be a reference to the loop, not a hardcoded name
  createjs.Sound.on('fileload', LoadUtil.loopSoundLoaded, undefined, true);
  createjs.Sound.registerSound(src, LoadUtil._loopSound);
};

LoadUtil.loopSoundLoaded = function (e): void {
  //TestUtil.log("loopSoundLoaded");
  UIUtil.delay(LoadUtil.playLoopSound, 2000);
};

LoadUtil.playLoopSound = function () {
  //TestUtil.log("playLoopSound");
  if (!LoadUtil._muted && LoadUtil._loopSound != null) {
    soundLoopInstance = createjs.Sound.play(LoadUtil._loopSound);
    soundLoopInstance.volume = 0.5;
    soundLoopInstance.on(
      'complete',
      function () {
        LoadUtil.restartLoop();
      },
      this,
    );
  }
};
LoadUtil.adjustLoopVolume = function (v) {
  if (
    !LoadUtil._muted &&
    LoadUtil._loopSound != null &&
    soundLoopInstance != null
  ) {
    soundLoopInstance.volume = v;
  }
};

//Private static methods
LoadUtil._toVarsObj = function (varsString) {
  const obj = {};
  const pairs = varsString.toString().split('&');
  for (const i in pairs) {
    const pair = pairs[i].split('=');
    try {
      obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    } catch (e) {
      try {
        pair[1] = pair[1].replace(/\%B0/g, '%C2%B0'); // fix ° glitch
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      } catch (e) {
        obj[decodeURIComponent(pair[0])] = pair[1];
      }
    }
  }
  return obj;
};
